"use client";
import * as React from "react";
import { PhoneCall, DollarSign } from "lucide-react";
import { IconBrandGoogleHome } from "@tabler/icons-react";


export default function WhyChooseUs() {
  return (
    <section className="py-12 lg:py-[4.5rem] overflow-hidden w-full">
      <div className="container mx-auto px-5 md:px-8 lg:px-0 flex flex-col items-center gap-12 max-w-7xl">
        {/* Top Content Section */}
        <div className="w-full flex flex-col items-center justify-center text-center">
          <span className="text-sm text-primary mb-2 block">
            Residential, Personal, and Industrial Construction Experts
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            <span className="font-normal lg:text-[2.05rem]">
              Your construction partner for Homes, Businesses, and Industry
            </span>
          </h2>
        </div>

        {/* Main Content Wrapper */}
        <div className="w-full lg:flex lg:gap-10 relative">
          {/* Card */}
          <div className="w-full lg:max-w-2xl lg:bg-background lg:pt-12 relative z-10">
            <div className="grid gap-7 lg:gap-8">
              {/* Card 1 */}
              <div className="flex flex-col md:flex-row gap-4 lg:gap-6">
                <div className="rounded-md w-20 h-20 border border-primary flex items-center justify-center flex-shrink-0">
                  <IconBrandGoogleHome className="w-8 h-8 text-primary" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">
                    Residential, Personal, and Industrial Guidance
                  </h3>
                  <p className="text-foreground/80">
                    Our team offers expert advice for every type of project,
                    whether it’s your home, a unique personal space, or an
                    industrial facility.
                  </p>
                </div>
              </div>

              {/* Card 2 */}
              <div className="flex flex-col md:flex-row gap-4 lg:gap-6">
                <div className="rounded-md w-20 h-20 border border-primary flex items-center justify-center flex-shrink-0">
                  <PhoneCall className="w-8 h-8 text-primary" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">
                    Get a Free Quote for any project
                  </h3>
                  <p className="text-foreground/80">
                    Connect with us for a no-obligation quote about your
                    residential, personal, or industrial construction plans.
                  </p>
                </div>
              </div>

              {/* Card 3 */}
              <div className="flex flex-col md:flex-row gap-4 lg:gap-6">
                <div className="rounded-md w-20 h-20 border border-primary flex items-center justify-center flex-shrink-0">
                  <DollarSign className="w-8 h-8 text-primary" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">
                    Value for Every Project Type
                  </h3>
                  <p className="text-foreground/80">
                    We deliver quality and efficiency for residential, personal,
                    and industrial builds, maximizing the return on your
                    investment.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative w-full lg:max-w-[550px] h-[500px] mt-12 lg:mt-0">
            <div className="relative w-4/5 h-[80%]">
              <img
                src="/images/98e9765c083daa10649b12c4af70494e.jpg"
                className="rounded-md w-full h-full object-cover shadow-lg"
              />

              {/* Overlay Box */}
              <div className="rounded-md border bg-background p-4 w-3/5 -mt-10 ml-6 relative z-10">
                <span className="block font-bold mb-1">
                  Residential, Personal, and Industrial Excellence
                </span>
                <span className="text-sm text-primary">
                  Superior workmanship and satisfaction for every project type
                  in Montreal.
                </span>
              </div>
            </div>

            {/* Second Image */}
            <div className="w-[40%] h-[40%] absolute bottom-0 right-0">
              <img
                src="/images/4ed7f5b8d836f9b575bf7936dcfdae0b.jpg"
                className="rounded-md w-full h-full object-cover shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
